import { onbrandUtilityFunctions } from "onbrandutilityfunctions";

function thumbnailImage() {
    const streamId = document.querySelector('#page-type-identifier').dataset.collectionId;
    if (streamId === '7140932' || streamId === '3229475') {
        if (document.querySelector('.item-level-image') === null) {
            const imageURL = document.querySelector(`meta[property='og:image']`).content;
            if (imageURL) {
                const imgHTML = `<img src="${imageURL}" class="item-level-image" style="height:auto;width:100%;">`;

                const container = document.querySelector('#hubs-container');
                if (container) {
                    container.querySelector('#item-content').insertAdjacentHTML('afterbegin', imgHTML);

                    document.querySelector('.items-div').insertAdjacentElement('afterbegin', document.querySelector('.ob-custom-sidebar'));
                }
            }
        }
    }
}

function customerStories() {

    const streamId = document.querySelector('#page-type-identifier').dataset.collectionId;
    if (streamId === '3615294') {
        const article = document.querySelector('.entry');
        const section = article.querySelector('section');
        if (section) {
            if (document.querySelector('.cs-heading') === null) {
                const heading = document.createElement('div');
                heading.classList.add('cs-heading');
                heading.appendChild(section.querySelector('h3'));
                section.insertAdjacentElement('afterbegin', heading);

                const sec1 = document.createElement('div');
                sec1.classList.add('section-1');
                sec1.appendChild(section.querySelectorAll('h5')[0]);
                sec1.appendChild(section.querySelectorAll('p')[0]);
                heading.insertAdjacentElement('afterend', sec1);

                const sec2 = document.createElement('div');
                sec2.classList.add('section-2');
                sec2.appendChild(section.querySelectorAll('h5')[1]);
                sec2.appendChild(section.querySelectorAll('p')[1]);
                sec1.insertAdjacentElement('afterend', sec2);

                const sec3 = document.createElement('div');
                sec3.classList.add('section-3');
                if (section.querySelectorAll('h5').length > 2) {
                    sec3.appendChild(section.querySelectorAll('h5')[2]);
                }
                sec2.insertAdjacentElement('afterend', sec3);
                const ptag = section.querySelectorAll('p');
                let p = 2;
                ptag.forEach((tag) => {
                    if (p < ptag.length) {
                        sec3.appendChild(section.querySelectorAll('p')[p]);
                        p = p + 1;
                    }
                });

                const globalDiv = document.createElement('div');
                globalDiv.classList.add('common-div');
                globalDiv.appendChild(document.querySelector('.section-1'));
                globalDiv.appendChild(document.querySelector('.section-2'));
                globalDiv.appendChild(document.querySelector('.section-3'));
                heading.insertAdjacentElement('afterend', globalDiv);
            }

            if (document.querySelector('.ob-custom-author')) {
                document.querySelector('.meta-inner').classList.add('has-author-child');
            }
            setTimeout(function() {
                if (article.querySelector('a').innerHTML === 'Read the full story &gt;') {
                    article.querySelector('a').style.display = 'none';
                }
                if (article.querySelector('strong').innerHTML === 'Read the full story &gt;' || article.querySelector('strong a').innerHTML === 'Read the full story &gt;') {
                    article.querySelector('strong').style.display = 'none';
                }
            }, 500);

        }
    }
}

function removeLogo() {
    setTimeout(function() {
        const texts = window.ReplaceData.Items;
        Object.keys(texts).map((streamID) => {
            const stream = document.querySelector(`.item-${streamID}`);
            if (stream) {
                const replaceText = texts[streamID].replaceText;
                if (document.querySelector('.ob-custom-copresenter')) {
                    document.querySelector('.ob-custom-copresenter').style.display = 'none';
                    document.querySelector('.ob-custom-author p').innerHTML = replaceText;
                }
            }
            return stream;
        });
    }, 500);
    const tiles = document.querySelectorAll('.tile:not(.cta)');
    let i = 0;
    tiles.forEach((tile) => {
        if (i > 2) {
            tile.style.display = 'none';
        }
        i = i + 1;
    });
}

function sectionThreeColumn() {
    const itemPage = document.querySelector('.single-page');
    if (!itemPage) {
        return;
    }
    const entry = document.querySelector('.entry');
    if (!entry) {
        return;
    }
    const section = entry.firstElementChild.tagName;
    if (section === 'SECTION') {
        const mainHeading = entry.getElementsByTagName('h3')[0];
        if (mainHeading) {
            const heading = `<div class="cs-heading"></div>`;
            entry.firstElementChild.insertAdjacentHTML('afterbegin', heading);
            const t = entry.firstElementChild.querySelector('.cs-heading');
            t.insertAdjacentElement('afterbegin', entry.getElementsByTagName('h3')[0]);
        }
        const allHeadings = entry.firstElementChild.querySelectorAll('h5');
        if (allHeadings) {
            const common = `<div class="common-div">
            <div class="section-1"></div>
            <div class="section-2"></div>
            <div class="section-3"></div>
            </div>`;
            entry.firstElementChild.insertAdjacentHTML('beforeend', common);
            allHeadings.forEach((h, i) => {
                if (i === 0) {
                    const target = entry.firstElementChild.querySelector('.common-div .section-1');
                    while (h.nextElementSibling.nodeName === 'P' || h.nextElementSibling.nodeName === 'A') {
                        target.insertAdjacentElement('beforeend', h.nextElementSibling);
                        if (!h.nextElementSibling.nodeName === 'P' || !h.nextElementSibling.nodeName === 'A') {
                            break;
                        }
                    }
                    target.insertAdjacentElement('afterbegin', h);
                } else if (i === 1) {
                    const target = entry.firstElementChild.querySelector('.common-div .section-2');
                    while (h.nextElementSibling.nodeName === 'P' || h.nextElementSibling.nodeName === 'A') {
                        target.insertAdjacentElement('beforeend', h.nextElementSibling);
                        if (!h.nextElementSibling.nodeName === 'P' || !h.nextElementSibling.nodeName === 'A') {
                            break;
                        }
                    }
                    target.insertAdjacentElement('afterbegin', h);
                } else {
                    const target = entry.firstElementChild.querySelector('.common-div .section-3');
                    while (h.nextElementSibling.nodeName === 'P' || h.nextElementSibling.nodeName === 'A') {
                        target.insertAdjacentElement('beforeend', h.nextElementSibling);
                        if (!h.nextElementSibling.nodeName === 'P' || !h.nextElementSibling.nodeName === 'A') {
                            break;
                        }
                    }
                    target.insertAdjacentElement('afterbegin', h);
                }
            });
        }
    }
}

// Move this javascript code form onbrandUtilityFunctions.js file
function sliderlTitle() {
    const heading = document.getElementById('related-items-heading');
    if (heading) {
        heading.innerHTML = '3 Key Resources To Check Out';
    }
}

function changePlacement() {
    setTimeout(function() {
        const sidebar = document.querySelector('div.ob-custom-sidebar');
        const itemData = document.querySelector('div.item-data');
        const level3 = itemData.querySelector('section.level-three>h1');
        const h = document.querySelector('.entry-wrapper>h1');
        const streamId = document.querySelector('#page-type-identifier').dataset.collectionId;
        if (h !== null) {
            $(sidebar).insertAfter(h);
        } else {
            $(sidebar).insertAfter(level3);
        }
    }, 500);
}

export { thumbnailImage, customerStories, removeLogo, sectionThreeColumn, sliderlTitle, changePlacement };


// WEBPACK FOOTER //
// ./script-partials/itemlevelSettings.js